module.exports = __webpack_public_path__ + "img/title.09248f8c.jpg";